import React from "react";
import { navigate } from "gatsby";
import ReactPaginate from "react-paginate";
function addSlashIfMissing(path) {
  if (path.substring(path.length - 1) === "/") {
    return path;
  }
  return `${path}/`;
}
// eslint-disable-next-line
export default function Pagination({ pageCount, index, pathPrefix }) {
  const pathPrefixWithEndingSlash = addSlashIfMissing(pathPrefix);
  return (
    <ReactPaginate
      pageCount={pageCount}
      breakClassName="inline-block font-thin"
      pageRangeDisplayed={3}
      marginPagesDisplayed={2}
      initialPage={index - 1}
      containerClassName="inline-block mb-6 text-lg font-semibold"
      activeClassName="text-primary"
      pageClassName="inline-block px-2"
      disabledClassName="hidden"
      previousClassName="inline-block px-2"
      nextClassName="inline-block px-2"
      hrefBuilder={pageNumber =>
        pageNumber === 1 ? `${pathPrefixWithEndingSlash}` : `${pathPrefixWithEndingSlash}${pageNumber}/`
      }
      onPageChange={({ selected }) => {
        const pageNumber = selected + 1;
        if (pageNumber === index) {
          return;
        }
        if (pageNumber === 1) {
          navigate(`${pathPrefixWithEndingSlash}`);
        } else {
          navigate(`${pathPrefixWithEndingSlash}${selected + 1}/`);
        }
      }}
    />
  );
}
